/**
 * @license
 * Copyright (C) 2022 Anna Plodari
 * Software proprietario - Tutti i diritti riservati.
 * Registrato SIAE - Sezione OLAF.
 *
 * È vietato qualsiasi utilizzo non autorizzato, copia, modifica, estrazione,
 * riuso, rielaborazione, distribuzione, reverse engineering o decompilazione
 * del software, delle API, delle logiche applicative e dei dati del database.
 *
 * L'accesso al codice non costituisce concessione di licenza.
 */
import React from 'react';
import UpgradeCard from '../../components/UpgradeCard';

const UpgradeCardCrediti: React.FC = function UpgradeCardCrediti() {
    return (
        <>
        <div className="relative flex gap-x-10 justify-center">
            <div className="relative flex flex-col lg:flex-row space-x-0 lg:space-x-10 space-y-6 lg:space-y-0 justify-center items-center mt-16">
                {/* CARD CREDITI */}
                <UpgradeCard 
                name="APL Card" 
                price="5.000€" 
                buttonText="Acquista" 
                to="mailto:support@hrmeccatronica.com?subject=Sono interessato al pacchetto APL Card">
                    <li>
                        <b>10</b> profili a scelta
                    </li>
                    <li>Nessuna scadenza</li>
                    <li>Garanzia crediti<sup>*</sup></li>
                </UpgradeCard>
            </div>
            <div className="relative flex flex-col lg:flex-row space-x-0 lg:space-x-10 space-y-6 lg:space-y-0 justify-center items-center mt-16">
                {/* CARD CREDITI */}
                <UpgradeCard 
                name="Top APL Card" 
                price="15.000€" 
                buttonText="Acquista" 
                to="mailto:support@hrmeccatronica.com?subject=Sono interessato al pacchetto Top APL Card">
                    <li>
                        <b>50</b> profili a scelta
                    </li>
                    <li>Nessuna scadenza</li>
                    <li>Garanzia crediti<sup>*</sup></li>
                </UpgradeCard>
            </div>
            </div>
            <div className="relative flex flex-col items-center mt-6 space-y-4 max-w-lg text-center mx-auto pb-10 lg:pb-0 mb-6">
                <p className="text-[11px] text-black font-primarylight">
                    * Garanzia Crediti: ottieni sempre il colloquio di lavoro o riconverti il credito. Si applica nel caso in cui il candidato non sia reperibile telefonicamente o via email per 7 giorni consecutivi dal primo tentativo di contatto o non sia più disponibile ad un colloquio di lavoro.
                </p>
            </div>
            </>
    );
};

export default UpgradeCardCrediti;
